import { createStore, applyMiddleware, combineReducers } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'
import thunkMiddleware from 'redux-thunk'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import appState from 'store/AppState'
import reports from 'store/Reports'
import venues from 'store/Venues'

const persistAppStateConfig = {
  storage,
  key: 'root',
  whitelist: ['appState']
}

const persistVenueConfig = {
  storage,
  key: 'reports',
  whitelist: ['prevFirstReportID', 'selectedVenue', 'firstReportID']
}

const persistVenuesConfig = {
  storage,
  key: 'venues',
  whitelist: ['selectedId']
}

const rootReducer = combineReducers({
  appState,
  reports: persistReducer(persistVenueConfig, reports),
  venues: persistReducer(persistVenuesConfig, venues)
})

const persistedReducer = persistReducer(persistAppStateConfig, rootReducer)

const middleware = composeWithDevTools(applyMiddleware(thunkMiddleware))

const store = () => {
  const store = createStore(persistedReducer, middleware)
  const persistor = persistStore(store)

  return { store, persistor }
}

export default store
